import {
  RouteReuseStrategy,
  DetachedRouteHandle,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Injectable } from '@angular/core';
import { ResultsComponent } from './results.component';
import { FrontpagePageComponent } from '../../pages/frontpage-page/frontpage-page.component';

@Injectable()
export class ResultsReuseStrategy implements RouteReuseStrategy {
  private stored = new Map<string, DetachedRouteHandle>();

  shouldDetach(route: ActivatedRouteSnapshot): boolean {    
    return route.routeConfig?.component === FrontpagePageComponent;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    const key = this.getKey(route);
    this.stored.set(key, handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const key = this.getKey(route);
    return this.stored.has(key);
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const key = this.getKey(route);
    return this.stored.get(key) || null;
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  private getKey(route: ActivatedRouteSnapshot): string {
    // include query-params e.g. ?src=netflix is part of the key
    const url = route.pathFromRoot
      .map(v => v.url.map(s => s.toString()).join('/'))
      .filter(s => s.length)
      .join('/');
    const qs = Object.entries(route.queryParams)
      .map(([k, v]) => `${k}=${v}`)
      .join('&');
    return qs ? `${url}?${qs}` : url;
  }
}
